module.exports = __webpack_public_path__ + "img/0x80d5f92c2c8c682070c95495313ddb680b267320.64b3f95c.png";